export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: 'Dashboard',
        icon: {
          src: require('@/assets/img/element-4.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'All Candidate',
        to: 'InterviewCandidateList',
        icon: {
          src: require('@/assets/img/profile-2user.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Selected Candidate',
        to: 'ShortlistedCandidate',
        icon: {
          src: require('@/assets/img/user-tick.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Video List',
        to: 'VideoList',
        icon: {
          src: require('@/assets/img/video-square.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Applicant',
        to: 'ManageApplicant',
        icon: {
          src: require('@/assets/img/Document.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ManageQR',
        to: 'ManageQR',
        icon: {
          src: require('@/assets/img/Document.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
        icon: {
          src: require('@/assets/img/GearSix.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        // icon: {
        //   src: './assets/img/briefcase1.png', // Replace '/path/to/custom/image.png' with the actual path to your custom image
        //   width: 24, // Specify the width of the image
        //   height: 24 // Specify the height of the image
        // },
      },
      
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]